import React from 'react';
import '../../CustomModule.css';
import { getControlStyle } from '../../../../../Components/helper';
import CommonAction from './CommonAction';

export function Colorfill({
  charCount,
  maxCount,
  fromForm,
  duplicatingItem,
  editingInput,
  pageIndex,
  gridIndex,
  showDelete,
  deleteItem,
  supplierVisible,
  handleSupplierPermission,
  otherConfiguration,
  setOnElement,
  onElement,
  handleStaticGrid,
  isStatic,
}) {
  const handleDuplicateItem = () => {
    duplicatingItem(gridIndex, pageIndex);
    setOnElement(false);
  };

  const combinedStyles = getControlStyle(otherConfiguration);

  return (
    <div>
      <div className="control-colorfill" style={combinedStyles} />
      {fromForm && onElement && (
        <CommonAction
          editingInput={editingInput}
          gridIndex={gridIndex}
          pageIndex={pageIndex}
          showDelete={showDelete}
          deleteItem={deleteItem}
          handleDuplicateItem={handleDuplicateItem}
          supplierVisible={supplierVisible}
          handleSupplierPermission={handleSupplierPermission}
          handleStaticGrid={handleStaticGrid}
          isStatic={isStatic}
        />
      )}
      {charCount && <div className="text-count">0/{maxCount}</div>}
    </div>
  );
}
export default Colorfill;
